import { useEffect, useState } from 'react'

import MiniHeader from '../../../../../UI/MiniHeader'
import MiniProgressBar from '../../../../../UI/MiniProgressBar'
import MiniStep from '../../../../../UI/MiniProgressBar/MiniStep'
import RevenuesExpenses from './RevenueExpenses'
import CorporateIncome from './CalculationOfCorporateIncome'
import styles from './style.module.scss'
import { TApi } from '../../../../../shared/const'
import http from '../../../../../shared/http'
import CalculationOfNetProfit from './CalculationOfNetProfit'
import CalculationOfLevisToJunior from './CalculationOfLeviesToJunior'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import SubmittedNotice from '../SubmittedNotice'

export default function ReportCompact(props) {
	const { t } = useTranslation()
	const steps = [
		{
			title: t('Calculation of profit loss before taxes')
		},
		{
			title: t('Calculation of corporate income tax')
		},
		{
			title: t('Calculation of net profit/loss')
		},
		{
			title: t('Calculation of levies to Junior')
		}
	]
	const [currentStep, setCurrentStep] = useState(1)
	const [isLoading, setLoading] = useState(false)
	const [formData, setFormData] = useState(null)

	const nextStep = e => {
		setCurrentStep(currentStep + 1)
	}

	const prevStep = e => {
		setCurrentStep(currentStep - 1)
	}

	const fetchData = () => {
		setLoading(true)
		http.get(TApi.STUDENT_REPORTS)
			.then(({ data }) => {
				setFormData(data.SemiannualReport)
			})
			.finally(() => {
				setLoading(false)
			})
	}

	const updateData = async form => {
		setLoading(true)
		return http
			.put(TApi.STUDENT_REPORTS, { type: 'SEMIANNUAL', ...form })
			.then(({ data }) => {
				setFormData(data)
			})
			.finally(() => setLoading(false))
	}
	useEffect(() => {
		!props.data && fetchData()
		props.data && setFormData(props.data)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div className={styles.root}>
			<MiniHeader title={t('Annual financial statements')} bg="#F8FAFF" />
			<SubmittedNotice isSubmitted={!!formData?.isSubmitted} />
			<MiniProgressBar bg="#F8FAFF">
				{steps.map((v, i, a) => {
					return (
						<MiniStep
							key={i}
							needStep={i}
							currentStep={currentStep}
							allSteps={a.length}
							title={v.title}
							bg="#F8FAFF"
							onClick={e =>
								formData?.isSubmitted ? setCurrentStep(i + 1) : i < currentStep && setCurrentStep(i + 1)
							}
						/>
					)
				})}
			</MiniProgressBar>

			<div className="container">
				<RevenuesExpenses
					isLoading={isLoading}
					form={formData}
					updateData={updateData}
					currentStep={currentStep}
					needStep={1}
					handlerNextStep={nextStep}
				/>
				<CorporateIncome
					isLoading={isLoading}
					form={formData}
					updateData={updateData}
					currentStep={currentStep}
					needStep={2}
					handlerNextStep={nextStep}
					handlerPrevStep={prevStep}
				/>
				<CalculationOfNetProfit
					isLoading={isLoading}
					form={formData}
					updateData={updateData}
					currentStep={currentStep}
					needStep={3}
					handlerNextStep={nextStep}
					handlerPrevStep={prevStep}
				/>
				<CalculationOfLevisToJunior
					isLoading={isLoading}
					form={formData}
					updateData={updateData}
					currentStep={currentStep}
					needStep={4}
					handlerPrevStep={prevStep}
				/>
			</div>
		</div>
	)
}
ReportCompact.propTypes = {
	data: PropTypes.object
}
